import { Link } from "react-router-dom";
import { useCarpetforEverySpot } from "../hooks/useCarpetforEverySpot";
import { getListingUrl } from "../../../utils/url.utils";

function CarpetforEverySpot() {
  const { carpets, loading } = useCarpetforEverySpot();
  if (loading || !carpets.length) return null;
  return (
    <section>
      <div className="carpet-section">
        <h2 className="carpet-heading">
            Carpet for <em>Every Spot</em>
        </h2>

     <div className="carpet-grid">
  {carpets.map((item) => (
    <Link key={item.id} to={getListingUrl(item.link)}>
      <div className="carpet-tile">
        <img src={item.image} alt={item.title} />
        <div className="carpet-label">{item.title}</div>
      </div>
    </Link>
  ))}
</div>
      </div>
    </section>
  );
}

export default CarpetforEverySpot;